import React, { useEffect, useState } from "react";
import axios from "axios";

const Banner = () => {
  const [data, setData] = useState(null);
 
 useEffect(() => {  
    async function fetchBannerData() {
      try {  
      const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careers`);  
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events); 
        setData(events.levelUp);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching banner data:", error);
      } 
    }
    fetchBannerData();
 },[]);


  if (!data) return null;

  return (
    <div className="text-white py-10 px-6 md:px-12 flex flex-col md:flex-row items-center" style={{
      backgroundImage: `url(${data?.backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    }}>
      {/* Left Section */}
      <div className="md:md:[width:-webkit-fill-available] text-center md:text-left">
        <h1 className="text-3xl md:text-4xl font-bold">
          {data.title} <span className="text-yellow-400">{data.highlight}</span>
        </h1>
        <a href={data.buttonLink} className="mt-6 inline-block bg-yellow-400 text-black font-semibold px-5 py-3 rounded-lg shadow-md hover:bg-yellow-500">
          {data.buttonText}
        </a>
      </div>

      {/* Right Section - Image Grid */}
      <div className="mt-8 md:mt-0 flex justify-center">
        {/* <img src={`${process.env.REACT_APP_COURSE_API_BASEURL}${data.image}`} alt="Banner" className="w-full max-w-md md:max-w-[100%] h-auto rounded-lg shadow-md" /> */}
        <img src={data.image} alt="Banner" className="w-full max-w-md md:max-w-[100%] h-auto rounded-lg shadow-md"  loading="lazy" />
      </div>
    </div>
  );
};

export default Banner;
